import { Col, Row, Typography, Dropdown } from 'antd'
// import type { MenuProps } from 'antd';
import React from 'react'
import { FaPercentage } from 'react-icons/fa'
import { HiOutlineSpeakerphone } from 'react-icons/hi'
import { MdLoyalty } from 'react-icons/md'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Item1 from '../assets/synopsis-list-items/item-1.png'
import Item2 from '../assets/synopsis-list-items/item-2.png'
import Item3 from '../assets/synopsis-list-items/item-3.png'
import Item4 from '../assets/synopsis-list-items/item-4.png'
import Item5 from '../assets/synopsis-list-items/item-5.png'
import Item6 from '../assets/synopsis-list-items/item-6.png'
import Item7 from '../assets/synopsis-list-items/item-7.png'
import Item8 from '../assets/synopsis-list-items/item-8.png'
import HomeNavigationDrawer from './HomeNavigationDrawer'
import shopWiseAnalysisIcon from '../assets/reports/shopWiseAnalysisIcon.png'
import timeWiseAnalysisIcon from '../assets/reports/timeWiseAnalysisIcon.png'
import dayWiseAnalysisIcon from '../assets/reports/dayWiseAnalysisIcon.png'
import categoryWiseAnalysisIcon from '../assets/reports/CategoryIcon.jpeg'
import newReturningIcon from '../assets/reports/NewReturningIcon.jpeg'
import inclusionAnalysisIcon from '../assets/reports/InclusionIcon.jpeg'

function BackToPreviews({ width }) {
  const location = useLocation()
  const navigate = useNavigate()
  const { mobile } = useParams()

  const temp =
    location.pathname === '/' ||
    location.pathname === '/home' ||
    location.pathname === '/cumulative-data' ||
    location.pathname === '/discount' ||
    location.pathname === '/offers' ||
    location.pathname === '/promotions' ||
    location.pathname === '/loyalty-levels' ||
    location.pathname === '/loyalty-offers' ||
    location.pathname === '/loyalty' ||
    location.pathname === '/product-profiling'
      ? [
          {
            icon: <HiOutlineSpeakerphone />,
            title: ' Home ',
            location: '/home',
          },
          {
            icon: <MdLoyalty />,
            title: ' Cumulative Data ',
            location: '/cumulative-data',
          },
          {
            icon: <FaPercentage />,
            title: 'Discount Planning',
            location: '/discount',
          },
          {
            icon: <FaPercentage />,
            title: 'Loyalty',
            dropdown: [
              {
                // icon: <MdLoyalty />,
                // title: 'Loyalty Level',
                // location: '/loyalty-levels',
                key: '1',
                label: (
                  <Col onClick={() => navigate('/loyalty')}>
                    <li
                      style={{ cursor: 'pointer', padding: '0.5rem' }}
                      className={location.pathname === '/loyalty' ? 'whenActive br-1' : 'item'}
                    >
                      <Typography.Text className='color-white text-dark'>Loyalty</Typography.Text>
                    </li>
                  </Col>
                ),
              },
              {
                // icon: <MdLoyalty />,
                // title: 'Loyalty Level',
                // location: '/loyalty-levels',
                key: '2',
                label: (
                  <Col onClick={() => navigate('/loyalty-levels')}>
                    <li
                      style={{ cursor: 'pointer', padding: '0.5rem' }}
                      className={
                        location.pathname === '/loyalty-levels' ? 'whenActive br-1' : 'item'
                      }
                    >
                      <Typography.Text className='color-white text-dark'>
                        Loyalty Level
                      </Typography.Text>
                    </li>
                  </Col>
                ),
              },
              {
                key: '3',
                label: (
                  <Col onClick={() => navigate('/loyalty-offers')}>
                    <li
                      style={{ cursor: 'pointer', padding: '0.5rem' }}
                      className={
                        location.pathname === '/loyalty-offers' ? 'whenActive br-1' : 'item'
                      }
                    >
                      <Typography.Text className='color-white text-dark'>
                        Loyalty Offer
                      </Typography.Text>
                    </li>
                  </Col>
                ),
              },
            ],
          },
          // {
          //   icon: <FaTag />,
          //   title: 'Offer Planning',
          //   location: '/offers',
          // },
          // {
          //   icon: <FaGift />,
          //   title: 'Promotion Planning',
          //   location: '/promotions',
          // },

          {
            icon: <MdLoyalty />,
            title: 'Product Profiling',
            location: '/product-profiling',
          },
        ]
      : location.pathname.includes('/feedbackdetails') || location.pathname === '/feedbackanalytics'
      ? [
          // {
          //   title: 'History',
          //   location: '/history',
          // },
          // {
          //   title: 'Predication',
          //   location: '/predication',
          // },
          {
            title: 'Feedbacks',
            location: `/feedbackdetails/${mobile}`,
          },
        ]
      : location.pathname === '/shopwise-analysis' ||
        location.pathname === '/daywise-analysis' ||
        location.pathname === '/timewise-analysis' ||
        location.pathname === '/categorywise-analysis' ||
        location.pathname === '/newreturning-analysis' ||
        location.pathname === '/inclusion-analysis'
      ? [
          {
            icon: shopWiseAnalysisIcon,
            title: 'Shop Wise Analysis',
            location: '/shopwise-analysis',
          },
          {
            icon: dayWiseAnalysisIcon,
            title: 'Day Wise Analysis',
            location: '/daywise-analysis',
          },
          {
            icon: timeWiseAnalysisIcon,
            title: 'Time Wise Analysis',
            location: '/timewise-analysis',
          },
          {
            icon: categoryWiseAnalysisIcon,
            title: 'Category Wise Analysis',
            location: '/categorywise-analysis',
          },
          {
            icon: newReturningIcon,
            title: 'New & Returning Analysis',
            location: '/newreturning-analysis',
          },
          {
            icon: inclusionAnalysisIcon,
            title: 'Inclusion Analysis',
            location: '/inclusion-analysis',
          },
        ]
      : [
          {
            icon: Item1,
            title: 'Customers Segmentation',
            location: '/CustomersSegmentation',
          },
          {
            icon: Item2,
            title: 'Segment Transition',
            location: '/SegmentTransition',
          },
          {
            icon: Item3,
            title: 'Cross Campaign Analysis',
            location: '/CrossCampaignAnalytics',
          },
          {
            icon: Item4,
            title: 'Conversion Analysis',
            location: '/ConversionAnalysis',
          },
          {
            icon: Item5,
            title: 'Campaign Analysis',
            location: '/CampaignAnalysis',
          },
          {
            icon: Item6,
            title: 'Customers Response Analysis',
            location: '/CustomersResponseAnalysis',
          },
          {
            icon: Item1,
            title: 'Weather Analysis',
            location: '/weather-analysis',
          },
          {
            icon: Item7,
            title: 'Stores Performance',
            location: '/StoresPerformances',
          },
          {
            icon: Item8,
            title: 'RFM analysis',
            location: '/rfm-analysis',
          },
        ]

  return (
    <div className='BackToPreviews' style={{ width: width }}>
      <HomeNavigationDrawer />
      <ul className='list-wrapper'>
        <Row gutter={5} className='BackToProvide_container'>
          {temp.map((item, index) => {
            return item.location ? (
              <Col key={index} onClick={() => navigate(item.location)}>
                <li
                  className={location.pathname === item.location ? 'whenActive' : 'item'}
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate('/')}
                >
                  {location.pathname.includes('/feedbackdetails') ? (
                    ''
                  ) : location.pathname === '/' ||
                    location.pathname === '/home' ||
                    location.pathname === '/discount' ||
                    location.pathname === '/offers' ||
                    location.pathname === '/promotions' ||
                    location.pathname === '/loyalty-levels' ||
                    location.pathname === '/cumulative-data' ||
                    location.pathname === '/product-profiling' ||
                    location.pathname === '/loyalty' ||
                    location.pathname === '/loyalty-offers' ? (
                    item.icon
                  ) : (
                    <img src={item.icon} alt='icon' style={{ width: '2rem', height: '2rem' }} />
                  )}
                  <Typography.Text
                    className='color-white'
                    style={
                      location.pathname.includes('/feedbackdetails')
                        ? {
                            fontSize: 12,
                          }
                        : ''
                    }
                  >
                    {item.title}
                  </Typography.Text>
                </li>
              </Col>
            ) : item.dropdown ? (
              <Dropdown key={index} menu={{ items: item.dropdown }} trigger={['click']}>
                <li
                  className={
                    location.pathname === '/loyalty' ||
                    location.pathname === '/loyalty-offers' ||
                    location.pathname === '/loyalty-levels'
                      ? 'whenActive'
                      : 'item'
                  }
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    flexDirection: 'column',
                  }}
                >
                  {item.icon || (
                    <img src={item.icon} alt='icon' style={{ width: '2rem', height: '2rem' }} />
                  )}
                  <Typography.Text className='color-white'>
                    {location.pathname === '/loyalty-levels'
                      ? 'loyalty levels'
                      : location.pathname === '/loyalty-offers'
                      ? 'loyalty offers'
                      : 'loyalty'}
                  </Typography.Text>
                </li>
              </Dropdown>
            ) : (
              ''
            )
          })}
        </Row>
      </ul>
    </div>
  )
}

export default BackToPreviews
